import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";

import AntdTable from "../../../components/antdTable";
import LiveChatService from "../../../service/LiveChatService";

const LivechatLog = () => {
  const lcService = new LiveChatService();
  const [state, setState] = useState({
    logs: [],
    loading: true,
    filters: {},
    filteredTotal: 0,
    pageNo: 1,
    sorter: "",
    dateFilter: {},
    resetDate: false,
  });

  const filterRef = useRef(false);

  const logsColumns = [
    {
      title: "Contact Number",
      dataIndex: "cellPhone",
      key: "cellPhone",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Patient Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "MR Number",
      dataIndex: "medicalRecordNumber",
      key: "medicalRecordNumber",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Cleared By",
      dataIndex: "clearedBy",
      key: "clearedBy",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Cleared At (utc)",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      ellipsis: true,
      filter: false,
      width: 200,
    },
  ];

  const getSuggestions = async (key, value, filters) => {
    try {
      let attribute = key;
      const startDate =
        state.dateFilter.startDate !== undefined
          ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
          : null;

      const endDate =
        state.dateFilter.endDate !== undefined
          ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
          : null;

      const data = await lcService.getLogsListSuggestions(
        attribute,
        value,
        filters,
        startDate,
        endDate
      );

      return data.data.map((item) => ({ key: item, name: item }));
    } catch {
      return [];
    }
  };

  const applyFilters = async (filters) => {
    if (filterRef && filterRef.current) return;
    else {
      filterRef.current = true;
      setState((st) => ({ ...st, filters, loading: true }));
      try {
        let search = JSON.stringify(filters);
        const logs = await getData(state.pageNo, state.sorter, search);
        const rows = logs?.data?.rows;
        setState((st) => ({
          ...st,
          logs: rows,
          filteredTotal: logs.data.count,
          filters,
          pageNo: 1,
          total: logs.data.count,
          loading: false,
        }));
        filterRef.current = false;
        return logs.data;
      } catch (e) {
        setState((st) => ({
          ...st,
          logs: [],
          loading: false,
        }));
        filterRef.current = false;
      }
    }
  };

  const getDateFilter = (selectedDate) => {
    setState((st) => ({
      ...st,
      dateFilter: selectedDate,
      pageNo: 1,
    }));
  };

  const downloadCSV = async () => {
    let filters = JSON.stringify(state.filters);

    const data = await getData(state.pageNo, state.sorter, filters, true);
    return data?.data;
  };

  useEffect(
    () => {
      setState((st) => ({
        ...st,
        dateFilter: st.dateFilter,
        pageNo: st.pageNo,
      }));
    },
    [state.dateFilter]
  );

  useEffect(
    () => {
      applyFilters(state.filters);
    },
    [state.dateFilter]
  );

  const getData = async (pageNo, sorter, filter, csv = false) => {
    const startDate =
      state.dateFilter.startDate !== undefined
        ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
        : null;
    const endDate =
      state.dateFilter.endDate !== undefined
        ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
        : null;
    const response = await lcService.getLogs(
      pageNo,
      15,
      sorter,
      filter,
      startDate,
      endDate,
      csv
    );
    return response;
  };
  const onTableChange = async (pagination, _filters, sorterObj) => {
    const page = pagination.current;
    const field = sorterObj.field;
    const order = sorterObj.order
      ? sorterObj.order === "ascend"
        ? "asc"
        : "desc"
      : "";
    const sorter = field && order ? `${field}.${order}` : "";
    try {
      const pageNo = sorter !== state.sorter ? 1 : page;
      const updatedFilters = JSON.stringify(state.filters);
      const result = await getData(pageNo, sorter, updatedFilters);
      setState((st) => ({
        ...st,
        pageNo,
        logs: result.data.rows,
        sorter,
        loading: false,
      }));
    } catch (e) {
      console.error(e);
      setState((st) => ({ ...st, loading: false }));
    }
  };
  return (
    <AntdTable
      columns={logsColumns}
      data={state.logs}
      loading={state.loading}
      tableProps={{
        onChange: onTableChange,
        pagination: {
          current: state.pageNo,
          filteredTotal: state.filteredTotal,
        },
      }}
      searchPlaceholder="Search"
      getSuggestionsList={getSuggestions}
      filterFirstColumn={true}
      applyFilters={applyFilters}
      getDateFilter={getDateFilter}
      downloadCSV={downloadCSV}
      filename="patient_logs.csv"
    />
  );
};
const mapStateToProps = (state) => ({
  user: state.login.user,
});
export default withRouter(
  connect(
    mapStateToProps,
    null
  )(LivechatLog)
);
